import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import IdentityContext from '../../../contexts/IdentityContext';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { getWhitepages, Whitepage } from '../_api/WhitepageApi';
import ModuleContext from './ModuleContext';
import TableOfContentsContext from './TableOfContentsContext';

type WhitepagesContextValue = {
  whitepages: Whitepage[];
};

const WhitepagesContext = createContext<WhitepagesContextValue>({
  whitepages: [],
});

export default WhitepagesContext;

export function WhitepagesContextProvider({ children }: PropsWithChildren) {
  const handleError = useThrowAsyncError();

  const { identity } = useContext(IdentityContext);
  const { selectedModule } = useContext(ModuleContext);
  const { selectedNode } = useContext(TableOfContentsContext);

  const [whitepages, setWhitepages] = useState<Whitepage[]>([]);

  useEffect(() => {
    async function fetchWhitepages() {
      if (!selectedModule || !selectedNode) return;

      try {
        const { data } = await getWhitepages(selectedModule.id, selectedNode.id);

        setWhitepages(data);
      } catch (e) {
        handleError(e);
      }
    }

    if (identity.isTeacherAlike) fetchWhitepages();
  }, [identity, selectedModule, selectedNode, handleError]);

  return <WhitepagesContext.Provider value={{ whitepages }}>{children}</WhitepagesContext.Provider>;
}
